export default [
  {
    path: '/wap/index',
    name: 'wapIndex',
    component: resolve => require(['@/modules/wap'], resolve),
    meta: {
      htmlTitle: ''
    }
  },
  {
    path: '/wap/develop',
    name: 'wapdevelop',
    component: resolve => require(['@/modules/wap/develop'], resolve),
    meta: {
      htmlTitle: ''
    }
  },
  {
    path: '/wap/case',
    name: 'wapCase',
    component: resolve => require(['@/modules/wap/case'], resolve),
    meta: {
      htmlTitle: ''
    }
  },
  {
    path: '/wap/about',
    name: 'wapAbout',
    component: resolve => require(['@/modules/wap/about'], resolve),
    meta: {
      htmlTitle: ''
    }
  },
  {
    path: '/wap/merchants',
    name: 'wapMerchants',
    component: resolve => require(['@/modules/wap/merchants'], resolve),
    meta: {
      htmlTitle: ''
    }
  },
  {
    path: '/wap/supplyChains',
    name: 'wapSupplyChains',
    component: resolve => require(['@/modules/wap/solution/supplyChains'], resolve),
    meta: {
      htmlTitle: ''
    }
  },
  {
    path: '/wap/solutionProject',
    name: 'wapSolutionProject',
    component: resolve => require(['@/modules/wap/solution/solutionProject'], resolve),
    meta: {
      htmlTitle: ''
    }
  },
  {
    path: '/wap/labour',
    name: 'wapLabour',
    component: resolve => require(['@/modules/wap/solution/labour'], resolve),
    meta: {
      htmlTitle: ''
    }
  },
  {
    path: '/wap/finance',
    name: 'wapFinance',
    component: resolve => require(['@/modules/wap/solution/finance'], resolve),
    meta: {
      htmlTitle: ''
    }
  },
  {
    path: '/wap/synergy',
    name: 'wapSynergy',
    component: resolve => require(['@/modules/wap/solution/synergy'], resolve),
    meta: {
      htmlTitle: ''
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/wap.js